import { ModalStore } from 'ui/base/modal';

export class HomeStore {
  modal: ModalStore;

  constructor() {
    this.modal = new ModalStore();
  }
}
